import { getDeviceInfo, getServerTimes } from '@/api/center'
import { enterRoom, verityRoomUser } from '@/api/room'
import { deviceShowState } from '@/store/deviceInfo'
import styled from '@emotion/styled'
import AgoraRTC from 'agora-rtc-sdk-ng'
import dayjs from 'dayjs'
import { motion } from 'framer-motion'
import qs from 'qs'
import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { IoClose } from 'react-icons/io5'
import { useNavigate } from 'react-router-dom'
import { useSetRecoilState } from 'recoil'
import LoadButton from '../LoadButton'
import Modal from '../Modal'

const tipMap = {
  info: '请输入课堂房间号',
  error: '请输入正确的房间号',
  success: '请输入课堂房间号'
}

const tabs = [
  {
    name: '1对1临时课堂',
    type: '1v1'
  }
  // {
  //   name:'小班临时课堂',
  //   type:'xbk',
  // },
]

interface IProps {
  cancel: () => void
}

export default ({ cancel }: IProps) => {
  const [focusNum, setFocusNum] = useState<number>(0)
  const [roomNumList, setRoomNumList] = useState<string[]>(['', '', '', '', '', ''])
  const [inputDomList, setInputDomList] = useState<any>([])
  const [tipText, setTipText] = useState<string>(tipMap.info)
  const [errorTip, setErrorTip] = useState<boolean>(false)
  // 一个字都没输入要置灰
  const [isGary, setIsGary] = useState<boolean>(true)
  // tab切换类型
  const [tabType, setTabType] = useState<string>('1v1')
  const [tipState, setTipState] = useState(false)
  const setDeviceShow = useSetRecoilState(deviceShowState)
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    // TODO
    // let getDomInput: any = document.querySelectorAll(".number .shortInput");
    // this.ipt = getDomInput;
    // getDomInput[0] && getDomInput[0].focus();
    // document.addEventListener("keydown", this.enterEvent);
    // const userId = sessionStorage.userId;
    // const identity = sessionStorage.type == 1 ? 2 : 1;
    // const timeStamp = new Date().getTime();
    // let sign = md5(
    //   `userId=${userId}&identity=${identity}&timestamp=${timeStamp}&key=${import.meta.env.VITE_APP_MD5KEY}`
    // );
    //   getUserDetail({
    //     sign,
    //     userId,
    //     identity,
    //     timestamp: timeStamp
    //   })
    //   .then((res: any) => {
    //     if (res && res.data) {
    //       // this.$sa = res.data.mobile;
    //     }
    //   })
    //   .catch((e: any) => {
    //     console.warn(e);
    //   });

    //   getSwitchLine()
    //   .then((res: any) => {
    //     if (res && res.data === true) {
    //       localStorage.setItem("proxyServer", "1");
    //     } else {
    //       localStorage.removeItem("proxyServer");
    //     }
    //   })
    //   .catch((e: any) => {
    //     console.error(e);
    //   });

    const dom = document.querySelector('.input-box')
    if (dom) {
      const domList = dom.querySelectorAll('input') || []
      setInputDomList(domList)
      changeFocus(0)
    }
  }, [])

  const close = (): void => {
    cancel()
  }
  // 键盘事件
  const keyDown = (e: any): void => {
    if (e.keyCode === 13) {
      getDeviceChange()
      return
    }
    if (e.keyCode === 8) {
      keyDel(e)
      return
    }

    let key = -1
    if (e.keyCode > 47 && e.keyCode < 58) {
      key = Number(String.fromCharCode(e.keyCode))
    } else if (e.keyCode > 95 && e.keyCode < 106) {
      key = e.keyCode - 96
    }

    if (key > -1) {
      setRoomNumList((val) => {
        return val.map((v, i) => {
          if (focusNum === i) {
            return `${key}`
          }
          return v
        })
      })
      setIsGary(false)
      changeFocus(focusNum + 1)
    } else {
      setRoomNumList((val) => {
        return val.map((v, i) => {
          if (focusNum === i) {
            return ''
          }
          return v
        })
      })
    }
  }
  // 键盘删除事件
  const keyDel = (e: Event): void => {
    if (focusNum >= 0) {
      if (focusNum === 0) {
        setTipText(tipMap.info)
        setErrorTip(false)
      }
      setRoomNumList((val) => {
        return val.map((v, i) => {
          if (focusNum === i) {
            return ''
          }
          return v
        })
      })
      focusNum > 0 && changeFocus(focusNum - 1)
      setIsGary(true)
      roomNumList.forEach((el) => {
        if (el !== '') {
          setIsGary(false)
        }
      })
    }
  }
  // 改变焦点
  const changeFocus = (index: number): void => {
    if (index >= 6) {
      return
    }
    inputDomList[index] && inputDomList[index].focus()
    setFocusNum(index)
  }
  // 清空
  const clear = (): void => {
    // this.$set(this, 'roomNumList', ['', '', '', '', '', '']);
    setRoomNumList(['', '', '', '', '', ''])
    changeFocus(0)
    setTipText(tipMap.info)
    setErrorTip(false)
  }
  // 错误提示
  const errorTipMsg = (msg: string): void => {
    setTipText(msg)
    setErrorTip(true)
  }
  // 设备检测
  const getDeviceChange = async () => {
    const empty = roomNumList.findIndex((el) => {
      return el === ''
    })
    if (empty !== -1) {
      errorTipMsg(tipMap.error)
      console.log('请输入正确的房间号')
      return
    }
    const userid = localStorage.userid
    const userType = '1'
    // 获取设备
    const response = await getDeviceInfo({ userId: userid, userType })
    if (response.status === 0) {
      const deviceInfo = response.data[0]
      if (!deviceInfo) {
        setTipState(true)
        return
      }
      const devices = await AgoraRTC.getDevices()
      const videoinput = devices.filter((v) => v.kind === 'videoinput').map((v) => v.deviceId)
      // microphoneId
      if ((localStorage.masterCamera && !videoinput.includes(localStorage.masterCamera)) || (localStorage.viceCamera && !videoinput.includes(localStorage.viceCamera))) {
        localStorage.masterCamera = ''
        localStorage.viceCamera = ''
        setTipState(true)
        return
      }
      // 服务器时间
      let clientDate = await getServerTimes()
      clientDate = dayjs(clientDate).format('YYYY-MM-DD')
      const checkDate = dayjs(deviceInfo.createTime).format('YYYY-MM-DD')
      // 今天没有检测或者检测结果不正常（每天检测且必须通过）
      if (clientDate !== checkDate || deviceInfo.result === 0) {
        setTipState(true)
        return
      }
    }
    toTempRoom()
  }

  const toTempRoom = async () => {
    const roomId = roomNumList.join('')
    // //  todo 全局取
    const userId = localStorage.getItem('userid')
    const userType = 1
    verityRoomUser({ cname: roomId })
      .then((res: any) => {
        console.info('verity room ser res：', res)
        const { status } = res
        if (+status === 0) {
          let {
            roomInfo: { users = [] }
          } = res
          const roleMap: any = {
            1: '0',
            2: '1',
            3: '2'
          }
          if (!Array.isArray(users)) {
            users = []
            console.error('server returned an error！！！')
          }
          const myRole = roleMap['1'] // 0 1

          const role = ['老师', '学生', '监课']
          if (!Array.isArray(users)) {
            users = []
            console.error('server returned an error！！！')
          }
          const roleArr = users.length
            ? users.map((item: any) => {
                return item.role
              })
            : []

          if (!userId) {
            toast.error('没有登录，请登录后再试')
            return
          }

          if (!userType) {
            toast.error('无法确认身份，请登录后再试')
            return
          }

          // 判断 Id 是否存在
          const userExist = users.find((e: any) => e.userid.substr(2) === userId)
          if (userExist) {
            enterRoomHandle({ status: 0 }, roomId, userId)
            return
          } else if (roleArr.length && roleArr.indexOf(myRole) > -1) {
            enterRoomHandle({ status: -1, error: `当前房间已有${role[myRole]}` }, roomId, userId)
          } else {
            enterRoomHandle({ status: 0 }, roomId, userId)
            return
          }
        } else {
          enterRoomHandle({ status: -1, error: res.msg }, roomId, userId)
        }
      })
      .catch((err: Error) => {
        console.info('verity room error info :', err)
      })
  }

  const enterRoomHandle = (paramObj: any, roomId: string, userId: any) => {
    const param = {
      roomId,
      teacherId: userId
    }
    enterRoom(param)
      .then((result: any) => {
        console.info('enter room result', result)

        if (+paramObj.status === 0) {
          if (result.data) {
            const { classTime, heartBeatRate, lessonId, lessonTimeId, lessonType, event, studentId, studentHead, studentName, studentExpect } = result.data
            const q = {
              date: new Date(classTime * 1000).toLocaleDateString('sv-SE'),
              timesRange: `${classTime * 1000}-${(classTime + 3600) * 1000}`,
              lessonId,
              lessonType: 1,
              courseType: 0,
              lessonTimeId,
              heartBeatRate,
              // studentId,
              userid: userId,
              roomCode: roomId,
              masterCamera: localStorage.masterCamera,
              viceCamera: localStorage.viceCamera
            }
            console.log(q)
            navigate(`/room?${qs.stringify(q)}`)
          } else {
            const classTime = dayjs().unix()
            const q = {
              date: new Date(classTime * 1000).toLocaleDateString('sv-SE'),
              timesRange: `${classTime * 1000}-${(classTime + 3600) * 1000}`,
              lessonType: 1,
              courseType: 0,
              userid: userId,
              roomCode: roomId,
              masterCamera: localStorage.masterCamera,
              viceCamera: localStorage.viceCamera
            }
            navigate(`/room?${qs.stringify(q)}`)
          }
        } else {
          setTipText(paramObj.error || result.msg)
        }
      })
      .catch((err: Error) => {
        console.error('enter room error info :', err)
      })
  }

  return (
    <Container>
      <IoClose className="text-[#999] text-[30px] absolute top-[-10px] right-[-10px] hover:text-[#666] hover:scale-105 hover:cursor-pointer active:scale-95 transition" onClick={close} />
      <div className="temp-tabs">
        {tabs.map((item, i) => (
          <span key={i} className={`${tabType == item.type ? 'active' : ''}`} onClick={() => setTabType(item.type)}>
            {item.name}
          </span>
        ))}
      </div>
      <div className="icon-box">
        <span style={{ color: errorTip ? 'red' : '' }}>{tipText}</span>
      </div>
      <div className="input-box">
        {roomNumList.map((v, i) => (
          <input
            key={i}
            value={v}
            type="text"
            maxLength={1}
            min="0"
            max="9"
            autoComplete="off"
            onKeyUp={keyDown}
            onChange={() => {}}
            onFocus={() => changeFocus(i)}
            // @keyup.prevent="keyDown"
            // @keyup.delete="keyDel"
            // @focus="changeFocus(index)"
          />
        ))}
      </div>
      <div className="button-box">
        <div className="clear hover:scale-105 hover:cursor-pointer active:scale-95 transition" onClick={clear}>
          清空
        </div>
        {/* <!--     todo 需要评估v-scale 组件是否需要动态开关       --> */}
        {!isGary ? (
          <LoadButton
            loading={loading}
            onClick={async () => {
              setLoading(true)
              await getDeviceChange()
              setLoading(false)
            }}
            className="inter hover:scale-105 hover:cursor-pointer active:scale-95 transition"
          >
            进入房间
          </LoadButton>
        ) : (
          <div className="inter inter-gray">进入房间</div>
        )}
      </div>

      <Modal
        shadowClick={false}
        show={tipState}
        cancel={() => {
          setTipState(false)
          toTempRoom()
        }}
        header=""
        confirm={() => {
          setTipState(false)
          setDeviceShow(true)
        }}
        cancelText="暂不检测"
      >
        <div className="mx-auto my-[20px] w-[300px]">您尚未通过设备检测，可能影响上课，是否立即检测？</div>
      </Modal>
    </Container>
  )
}

const Container = styled(motion.div)`
  width: 400px;
  background: #ffffff;
  border-radius: 24px;
  text-align: center;
  position: relative;
  .close {
    position: absolute;
    color: #cccccc;
    right: 0;
    top: 0;
  }
  .temp-tabs {
    line-height: 24px;
    margin-bottom: 32px;
    display: flex;
    justify-content: center;
    & > span {
      padding: 0 12px;
      font-size: 20px;
      color: #666;
      font-size: 16px;
      cursor: pointer;
      height: 30px;
      &::before {
        content: '';
        left: 30px;
        transition: left 0.1s ease-in-out;
      }
      &.active {
        color: #ff575f;
        position: relative;
        font-weight: 500;
        &::before {
          position: absolute;
          display: block;
          left: 50%;
          bottom: 0;
          margin-left: -16px;
          width: 32px;
          height: 4px;
          background: #ff5050;
          border-radius: 2px;
        }
      }
    }
  }
  .icon-box {
    text-align: left;
    padding-left: 42px;
    .iconfont {
      width: 80px;
      height: 80px;
      display: block;
      background-color: rgba(255, 236, 236, 1);
      border-radius: 100%;
      margin: 32px auto 12px;
      color: rgba(255, 80, 80, 1);
      font-size: 32px;
      line-height: 80px;
    }
    span {
      font-size: 16px;
      font-weight: 300;
      color: #999999;
      line-height: 16px;
    }
  }
  .input-box {
    display: flex;
    margin-top: 16px;
    padding: 0 40px;
    justify-content: space-around;
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    input[type='number'] {
      -moz-appearance: textfield;
    }
    input {
      width: 48px;
      height: 48px;
      background: #f5f5f5;
      box-shadow: inset 1px 1px 3px 0 rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      box-sizing: border-box;
      border: none;
      outline-style: none;
      text-align: center;
      &:focus {
        border: 2px solid #ff5050;
      }
    }
  }
  .button-box {
    display: flex;
    justify-content: space-around;
    padding: 0 30px;
    margin-top: 40px;
    font-weight: 500;
    .inter {
      width: 156px;
      height: 48px;
      background: #ff5050;
      box-shadow: 0px 4px 0px 0px #d1385f;
      border-radius: 25px;
      color: #fff;
      line-height: 48px;
    }
    .inter-gray {
      background: #e3e3e3;
      box-shadow: 0px 4px 0px 0px #d7d7d7;
      color: #ffffff;
      cursor: pointer;
    }
    .clear {
      width: 156px;
      height: 48px;
      background: #fff4f4;
      box-shadow: 0px 4px 0px 0px #fbe7e7;
      border-radius: 25px;
      color: #ff5050;
      line-height: 48px;
    }
  }

  .fade-enter-active {
    animation: fade-in 1s ease-out;
  }

  .fade-leave-active {
    animation: fade-in 0.6s reverse ease-in;
  }
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`
